import ol from 'openlayers'
import ILayers from '../ILayers'

class _WMS extends ILayers {

	constructor(obj) {
		super()
		this.url = obj.url
		this.params = obj.params
		this.opacity = obj.opacity
		this.visibility = obj.visibility
		this.popup = obj.popup
		this.layer = this.createLayer()
	}

	createLayer = () => {
		return new ol.layer.Tile({
			opacity: this.getOpacity(),
			visibility: this.visibility,
			source: new ol.source.TileWMS({
				url: this.url,
				params: this.params
			})
		})
	}

	getOpacity = () => {
		return this.opacity ? this.opacity : 1
	}

	getLayer() {
		return this.layer
	}

	getPopup() {
		return this.popup
	}
}

export default function WMS(...args) {
	return new _WMS(...args)
}





// WEBPACK FOOTER //
// ./src/utils/mapUtils/layers/WMS.js